var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['corner', _vm.bgStyle]},[_c('div',{staticClass:"num flex flex-col"},[(_vm.correct)?_c('p',{class:['m-0', _vm.textColor]},[_c('BaseIcon',{attrs:{"name":"check"}})],1):_c('p',{class:['m-0', _vm.textColor]},[_c('BaseIcon',{attrs:{"name":"times"}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }